import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import PrivateApplicationForm from '../../components/PrivateApplicationForm/PrivateApplicationForm';
import useIsMobile from '../../hooks/useIsMobile';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import NeuralCanvas from '../../components/NeuralCanvas';
import './PrivateForm.css';

const PrivateForm = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  const { token } = useParams();
  const location = useLocation();
  const [isValidToken, setIsValidToken] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      // Si estamos en la ruta de desarrollo, consideramos el token válido
      if (location.pathname === '/dev-private-form') {
        setIsValidToken(true);
        return;
      }

      try {
        // Para desarrollo, simplemente validamos que exista un token
        if (token) {
          setIsValidToken(true);
        } else {
          setIsValidToken(false);
        }
        
        // La implementación real sería:
        // const response = await fetch(`/api/validate-token/${token}`);
        // const isValid = await response.json();
        // setIsValidToken(isValid);
      } catch (error) {
        console.error('Error validando token:', error);
        setIsValidToken(false);
      }
    };

    validateToken();
  }, [token, location.pathname]);

  const handleSubmit = (formData) => {
    console.log('Private Form submitted:', formData);
    // Aquí implementar la lógica de envío al backend
  };

  if (isValidToken === false) {
    return <Navigate to="/" replace />;
  }

  if (isValidToken === null) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <>
      <div className="overlay"></div>
      <NeuralCanvas />
      <LanguageSelector className={isMobile ? 'mobile-language-selector' : ''} />
      
      <div className={`private-form-page ${isMobile ? 'mobile-private-form-page' : ''}`}>
        <div className={`private-form-container ${isMobile ? 'mobile-private-form-container' : ''}`}>
          <div className="video-container">
            {/* Video por idioma (formulario privado) */}
            {(() => {
              const privateVideoIds = {
                de: 'AKA4E9Ak2Wo',
                ar: 'imBFYRByIoY',
                bn: 'cg2wClNUhy8',
                zh: 'isz_NRCZ0VM',
                es: '8UDzzpXHEmc',
                fr: '44zTNBHAUl8',
                hi: '8Uz3L0KFtmg',
                en: 'OA-xfGYzxaQ',
                pt: '4FWBCF2RwbI',
                ru: 'S2onxM6udCU'
              };
              const currentLang = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
              const videoId = privateVideoIds[currentLang] || privateVideoIds.en;
              return (
                <iframe
                  title="Private intro video"
                  src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{ width: '100%', height: '100%' }}
                ></iframe>
              );
            })()}
          </div>
          
          <div className="welcome-section">
            <p className="welcome-text">{t('privateForm.welcomeText')}</p>
          </div>

          <PrivateApplicationForm onSubmit={handleSubmit} isMobile={isMobile} />
        </div>
      </div>
    </>
  );
};

export default PrivateForm; 